import React from "react";
import { Dialog, DialogContent } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

type WarningType = "warning" | "error";

interface WarningDialogProps {
  open: boolean;
  onClose: () => void;
  message: string;
  btnStyle?: "contained" | "text" | "outlined" | "gradient";
  onConfirm?: () => void;
  confirmText?: string;
  cancelText?: string;
  showActions?: boolean;
  type?: WarningType;
}

const WarningDialog: React.FC<WarningDialogProps> = ({
  open,
  onClose,
  message,
  onConfirm,
  btnStyle = "contained",
  confirmText = "Confirm",
  cancelText = "Close",
  showActions = false,
  type = "warning",
}) => {
  const color = type === "error" ? "#f44336" : "#ff9800";
  const iconColor = "#fff";

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <MDBox
        height={100}
        display="flex"
        alignItems="center"
        justifyContent="center"
        sx={{
          backgroundColor: color,
          borderTopLeftRadius: "8px",
          borderTopRightRadius: "8px",
        }}
      >
        <WarningAmberIcon
          sx={{
            color: iconColor,
            width: "50px",
            height: "50px",
          }}
        />
      </MDBox>

      <DialogContent>
        <MDBox textAlign="center" pt={3} pb={2}>
          <MDTypography variant="body1" fontWeight="medium" mb={3}>
            {message}
          </MDTypography>

          {showActions && (
            <MDBox display="flex" justifyContent="center" gap={3} mt={3}>
              {onConfirm && (
                <MDButton variant={btnStyle} color="primary" onClick={onConfirm} size="large">
                  {confirmText}
                </MDButton>
              )}

              {onClose && (
                <MDButton
                  variant="outlined"
                  color={type === "error" ? "error" : "warning"}
                  onClick={onClose}
                  size="large"
                >
                  {cancelText}
                </MDButton>
              )}
            </MDBox>
          )}
        </MDBox>
      </DialogContent>
    </Dialog>
  );
};

export default WarningDialog;
